export default "__VITE_ASSET__DSCWwbUP__"